import { Remito } from "./Remito";

export class RemitoEnCuenta{
    cTA_SGC: string;
    remitos: Remito[];
}